import { call, put, takeLatest, all } from 'redux-saga/effects';
import axios from 'axios';
import history from '@history';
import FuseUtils from '@fuse/utils';
import { showMessage } from 'app/store/actions/fuse';
import * as Actions from '../../actions';

function* fetchClient(action) {
	const { clientId } = action.payload;
	try {
		const response = yield call(() => axios.get(`/api/v1/clients/${clientId}`));
		yield put(Actions.fetchClientSuccess(response.data));
	} catch (error) {
		yield put(
			showMessage({
				message: 'Unable to Retrieve Client ' + error,
				variant: 'error'
			})
		);
		yield put(Actions.fetchClientFailure());
	}
}

function* createClient(action) {
	let data = action.payload;
	data.clientId = `client-${FuseUtils.generateGUID()}`;

	try {
		const response = yield call(() => axios.post('/api/v1/clients', data));
		yield put(Actions.createClientSuccess(response.data));

		history.push(`/clients/${data.clientId}/edit`);

		yield put(
			showMessage({
				message: 'Client Saved',
				variant: 'success'
			})
		);
	} catch (error) {
		yield put(
			showMessage({
				message: `Unable to Save Client: 
                      ${error && error.response && error.response.data ? error.response.data.split('\n')[0] : ''}`,
				variant: 'error'
			})
		);
		yield put(Actions.createClientFailure());
	}
}

function* updateClient(action) {
	const data = action.payload;

	try {
		const response = yield call(() => axios.put('/api/v1/clients', data));
		yield put(Actions.updateClientSuccess(response.data));
		yield put(
			showMessage({
				message: 'Client Updated',
				variant: 'success'
			})
		);
	} catch (error) {
		yield put(
			showMessage({
				message: `Unable to Update Client: 
                      ${error && error.response && error.response.data ? error.response.data.split('\n')[0] : ''}`,
				variant: 'error'
			})
		);
		yield put(Actions.updateClientSuccess());
	}
}

function* deleteClient(action) {
	const clientId = action.payload;

	try {
		const response = yield call(() => axios.delete(`/api/v1/clients/${clientId}`));
		yield put(Actions.deleteClientSuccess(response.data));

		history.push('/clients');

		yield put(
			showMessage({
				message: 'Client Deleted',
				variant: 'success'
			})
		);
	} catch (error) {
		yield put(
			showMessage({
				message: 'Unable to Delete Client',
				variant: 'error'
			})
		);
		yield put(Actions.deleteClientFailure());
	}
}

function* createClientSecret(action) {
	const {clientId, secret} = action.payload;
	try {
		const response = yield call(() => axios.post(`/api/v1/clients/${clientId}/secrets`, secret));
		yield put(Actions.createClientSecretSuccess(response));
		yield put(showMessage({
			message: 'New Secret Created',
			variant: 'success'
		}))
	}
	catch (error) {
		yield put(showMessage({
			message: 'Unable to create secret ' + error, 
			variant: 'error'
		}));
		yield put(Actions.createClientSecretFailure(error));
	}
}

function* watchClient() {
	yield all([
		takeLatest(Actions.fetchClient, fetchClient),
		takeLatest(Actions.createClient, createClient),
		takeLatest(Actions.updateClient, updateClient),
		takeLatest(Actions.deleteClient, deleteClient),
		takeLatest(Actions.createClientSecret, createClientSecret)
	]);
}

export default watchClient;
